import React from 'react';
import ReactDOM from 'react-dom/client';
// ============================================
// LOGIN FUNCTIONALITY COMMENTED OUT
// ============================================
// import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from "./reportWebVitals";
import App from "./components/app";
import axios from 'axios';

// Configure axios defaults
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      {/* ============================================ */}
      {/* LOGIN FUNCTIONALITY COMMENTED OUT */}
      {/* ============================================ */}
      {/* <AuthProvider> */}
      <App />
      {/* </AuthProvider> */}
    </BrowserRouter>
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();